import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
  {
    name: 'Sarah Chen',
    role: 'E-commerce Owner',
    company: 'TechStyle Boutique',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13449e237-1766741167592.png",
    rating: 5,
    text: 'Upgrading to Pro was the best decision for our business. The reduced fees alone paid for the subscription in the first month.'
  },
  {
    name: 'Michael Rodriguez',
    role: 'Freelance Developer',
    company: 'DevCraft Solutions',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13671ffe4-1766288397964.png",
    rating: 5,
    text: 'The Pro tier analytics helped me understand my payment patterns and optimize my cash flow. Priority support is incredibly responsive.'
  },
  {
    name: 'Emily Thompson',
    role: 'CFO',
    company: 'GrowthTech Inc',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_118f7a2d8-1768262410423.png",
    rating: 5,
    text: 'Enterprise plan gave us the flexibility and support we needed. The dedicated account manager understands our unique requirements.'
  }];


  return (
    <div className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Trusted by Thousands</h2>
        <p className="text-gray-600">See what our customers have to say about BOLTPay</p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {testimonials?.map((testimonial, index) =>
        <div key={index} className="bg-white rounded-xl shadow-lg p-6 relative">
            <Quote className="absolute top-4 right-4 w-8 h-8 text-blue-100" />
            
            <div className="flex items-center gap-4 mb-4">
              <img
              src={testimonial?.image}
              alt={`${testimonial?.name} profile`}
              className="w-12 h-12 rounded-full object-cover" />

              <div>
                <h4 className="font-semibold text-gray-900">{testimonial?.name}</h4>
                <p className="text-sm text-gray-600">{testimonial?.role}</p>
                <p className="text-xs text-gray-500">{testimonial?.company}</p>
              </div>
            </div>

            <div className="flex gap-1 mb-3">
              {[...Array(testimonial?.rating)]?.map((_, i) =>
            <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            )}
            </div>

            <p className="text-gray-700 text-sm leading-relaxed">{testimonial?.text}</p>
          </div>
        )}
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
        <div className="text-center">
          <div className="text-4xl font-bold text-blue-600 mb-2">50K+</div>
          <div className="text-sm text-gray-600">Active Users</div>
        </div>
        <div className="text-center">
          <div className="text-4xl font-bold text-blue-600 mb-2">$2B+</div>
          <div className="text-sm text-gray-600">Processed</div>
        </div>
        <div className="text-center">
          <div className="text-4xl font-bold text-blue-600 mb-2">99.9%</div>
          <div className="text-sm text-gray-600">Uptime</div>
        </div>
        <div className="text-center">
          <div className="text-4xl font-bold text-blue-600 mb-2">4.9/5</div>
          <div className="text-sm text-gray-600">Rating</div>
        </div>
      </div>
    </div>);

};

export default TestimonialsSection;